import clsx from "clsx";
import { ForwardedRef } from "react";
import { ChevronUp } from "react-feather";
import { twMerge } from "tailwind-merge";
import { PropsWithAs } from "../../types";
import { forwardRefWithGeneric } from "../../utils";
import CardHeader, { CardHeaderProps } from "../cardHeader";
import { useCardContext } from "./context";

const CollapsibleCardHeader = <T extends React.ElementType = "div">(
  props: PropsWithAs<CardHeaderProps, T> & { mode?: "click" | "toggle" },
  ref: ForwardedRef<any>
) => {
  const { children, className, onClick, mode = "click", ...rest } = props;
  const { collapsed, setCollapsed } = useCardContext();

  return (
    <CardHeader
      {...(rest as any)}
      ref={ref}
      onClick={() => {
        if (mode === "click") {
          setCollapsed(!collapsed);
        }
      }}
      className={twMerge(
        "flex justify-between cursor-pointer select-none",
        className
      )}
    >
      {children}
      <button
        className="transition-all duration-300 hover:bg-slate-200 p-2 -m-2 rounded-full cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          if (mode === "toggle") {
            setCollapsed(!collapsed);
          }
        }}
      >
        <ChevronUp
          className={clsx("transition-transform", {
            "rotate-180": collapsed,
          })}
        />
      </button>
    </CardHeader>
  );
};

export default forwardRefWithGeneric(CollapsibleCardHeader);
